import type {
  ESignFormName,
  ESignFormStatusData,
  ESignFormStatusItem,
} from 'features/Procedure/state/procedure-api.type'

export const TAB_TO_FORM_NAME: Record<string, ESignFormName> = {
  treatments: 'soap_r',
  photos: 'photo',
  soap: 'soap_r',
  products: 'product',
  labs: 'labs',
}

// Tabs whose actions are locked once the encounter itself is signed. Every other
// tab is governed only by its own per-form sign flag, so it stays editable when
// the encounter is signed but its own form is not.
const ENCOUNTER_LOCKED_TAB_KEYS: ReadonlySet<string> = new Set(['treatments', 'soap'])

export const hasESignItems = (status?: Pick<ESignFormStatusItem, 'items'> | null): boolean => {
  return Array.isArray(status?.items) && status.items.length > 0
}

export const getTabSignedStatus = (
  eSignStatus: ESignFormStatusData | undefined,
  tabKey: string,
): boolean => {
  if (!eSignStatus) return false
  const formName = TAB_TO_FORM_NAME[tabKey]
  if (!formName) return false
  const status = eSignStatus[formName]
  return status?.is_signed === 1
}

export const getTabHasFormToSign = (
  eSignStatus: ESignFormStatusData | undefined,
  tabKey: string,
): boolean => {
  if (!eSignStatus) return false
  const formName = TAB_TO_FORM_NAME[tabKey]
  if (!formName) return false
  const status = eSignStatus[formName]
  return status?.has_form_to_sign === 1
}

export const getTabHasESignItems = (
  eSignStatus: ESignFormStatusData | undefined,
  tabKey: string,
): boolean => {
  if (!eSignStatus) return false
  const formName = TAB_TO_FORM_NAME[tabKey]
  if (!formName) return false
  return hasESignItems(eSignStatus[formName])
}

export const getIsEncounterSigned = (eSignStatus: ESignFormStatusData | undefined): boolean =>
  eSignStatus?.encounter?.is_signed === 1

export const getTabActionsDisabled = (
  eSignStatus: ESignFormStatusData | undefined,
  tabKey: string,
  isInteractionLocked = false,
): boolean => {
  if (isInteractionLocked) return true
  if (getTabSignedStatus(eSignStatus, tabKey)) return true
  return ENCOUNTER_LOCKED_TAB_KEYS.has(tabKey) && getIsEncounterSigned(eSignStatus)
}
